<template>
  <div class="complaint-success">
    <img class="complaint-success-icon" src="../../assets/img/complaint_success.png" alt="" />
    <p class="complaint-success-main">提交成功</p>
    <p class="complaint-success-sub">您反馈的问题我们已收到，请耐心等待处理结果</p>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
export default {
  name: 'ComplaintSuccess',
  data() {
    return {}
  },
  created() {
    native.setTitle({
      title: '投诉中心'
    })
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/base.less';
  .complaint-success {
    padding-top: 120px;
    &-icon {
      display: block;
      width: 80px;
      height: 80px;
      margin: 0 auto 32px;
    }
    &-main {
      font-size: 32px;
      font-weight: bold;
      color: #2e3135;
      text-align: center;
      margin-bottom: 20px;
    }
    &-sub {
      font-size: 28px;
      color: #777;
      text-align: center;
    }
  }
</style>
